import Controller from 'controllers/controller';
import Binder from 'tools/binder';
import Helpers from 'tools/helpers';
import createHistory from "history/createBrowserHistory";

class HistoryController extends Controller {
    constructor(app) {
        super(app);
        
        this.binder = new Binder(this);
        this.history = createHistory();
        
        this.ignoreNextPageChange = false;
        
        this.attachEvents();
    }
    
    attachEvents() {
        this.app.pageController.on('change', Helpers.delayedFunction(300, this.binder.bind('onPageChange')));
        
        this.history.listen(this.binder.bind('onHistoryChange'));
    }
    
    onHistoryChange(location, action) {
        // Ignore pushed states
        if (action === 'PUSH') {
            return;
        }

        this.ignoreNextPageChange = true;

        let page = this.app.pageController.getPageByUrl(location.pathname);

        this.app.pageController.setCurrentPage(page);
        this.app.pageController.scrollToPage(page);
    }
    
    onPageChange(page) {
        // Avoid pushing popped state
        if (this.ignoreNextPageChange) {
            this.ignoreNextPageChange = false;
            
            return;
        }
        
        this.setCurrentPage(page);
    }
    
    setCurrentPage(page) {
        this.history.push(page.url);
    }
}

export default HistoryController;